module.exports = __WEBPACK_EXTERNAL_MODULE_28__;


//////////////////
// WEBPACK FOOTER
// external "isogd-file-rest"
// module id = 28
// module chunks = 0